import { render, staticRenderFns } from "./TixstockPopularCategories.vue?vue&type=template&id=58d7edda"
import script from "./TixstockPopularCategories.vue?vue&type=script&lang=js"
export * from "./TixstockPopularCategories.vue?vue&type=script&lang=js"
import style0 from "./TixstockPopularCategories.vue?vue&type=style&index=0&id=58d7edda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports